import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import Icon from '../../../../components/icon';
import {Column, Row} from '../../../../components/layout';
import {colors} from '../../../../util/colors';
import {Icons} from '../../../../util/icons';
import {strings} from '../../../../util/strings';
import {createGUID, limitArray} from '../../../../util/utility';
import {ReimbursementItem} from '../interfaces';
import ReimbursementListItem from './ReimbursementListItem';
import {toUpper} from 'lodash';

export interface ReimbursementsListProps {
  changedItem(filterItem: ReimbursementItem): void;
  reimbursementItems?: ReimbursementItem[];
  statuses: any[];
  ReimbursementFinishedSubmitting(values?: any): void;
  labels: typeof strings.pt.refund;
  maxItems?: number;
}

function ReimbursementsList({
  reimbursementItems,
  statuses,
  changedItem,
  ReimbursementFinishedSubmitting,
  labels,
  maxItems,
}: ReimbursementsListProps) {
  return (
    /*if collection is empty, show message 'there are none'*/
    reimbursementItems?.length === 0 || !reimbursementItems?.length ? (
      <Column className="reimbursement-history-no-reimbursementsyet">
        <Icon
          className="reimbursement-no-results-history-filter-icon"
          name={Icons.ALERT_PROBLEM}
          color={colors.lightGrey}
          width="40"
          height="40"
          changeViewbox
          viewBox={'0 0 24 24'}
        />
        <h6
          className="reimbursement-list-header"
          style={{color: colors.lightGrey}}>
          {labels?.refundHistory_emptyList}
        </h6>
      </Column>
    ) : (
      <>
        <Row className="list-header-row">
          <Column className="reimbursement-history-header">
            <div className="reimbursement-history-header-text">
              {toUpper(labels?.medicalActIn)}
            </div>
          </Column>
        </Row>
        <div className="reimbursement-history-declarationlist-line"></div>
        {limitArray(reimbursementItems, maxItems)?.map(
          (element: ReimbursementItem) =>
            (parseInt(element.stateId, 10) < 101 ||
              parseInt(element.stateId, 10) >= 104) && (
              <div
                key={createGUID()}
                onClick={() => changedItem(element)}
                className="reimbursement-list-container">
                <ReimbursementListItem
                  key={createGUID()}
                  reimbursementItem={element}
                  statuses={statuses}
                  ReimbursementFinishedSubmitting={
                    ReimbursementFinishedSubmitting
                  }
                />
              </div>
            ),
        )}
      </>
    )
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.refund,
});

export default compose(connect(mapStateToProps)(ReimbursementsList));
